import Loader from './dots_loader'

export default Loader
